export const DOWNLOAD_FETCH_INTERVAL = 1000

export default {
  DOWNLOAD_FETCH_INTERVAL
}
